/**
 * @description
 * calculates "percent value" of any given "absolute value" out of any given "total" value
 * @param value absolute numeric value to calculate
 * @param total total value (represents 100%)
 * @returns the percent of "value" out of "total"
 */
export function calcPercent(value: number, total: number) {
  let pct = Math.floor((value * 100) / total);
  pct = Math.max(pct, 0);
  pct = Math.min(pct, 100);
  return pct;
}
